import { render, staticRenderFns } from "./CompanyLog.vue?vue&type=template&id=0791b7cb&scoped=true&"
import script from "./CompanyLog.vue?vue&type=script&lang=js&"
export * from "./CompanyLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0791b7cb",
  null
  
)

export default component.exports